import React, { useEffect, useState } from 'react';
import Slideshow from './Slideshow';
import { MarkDownView } from '../../common/MarkDownView';

function KvizPitanjeSingle({
    item,
    pitanjeIndex,
    surveyOdgovori,
    setSurveyOdgovori,
    showResults = false,
}: {
    item: any;
    pitanjeIndex: number;
    surveyOdgovori: any;
    setSurveyOdgovori: any;
    showResults?: boolean;
}) {
    const tacanOdgovor = item.odgovori.find((odgovor: any) => odgovor.tacan === true);
    const [showOpis, setShowOpis] = useState(false);
    const hasOpis = !!item?.opis?.trim();

    // Posle završetka testa opis odgovora se automatski otvara za pitanja koja nisu tačno rešena (ili nisu rešena).
    const osvojenoBodova = surveyOdgovori?.[pitanjeIndex]?.brojBodova ?? 0;
    useEffect(() => {
        if (showResults && osvojenoBodova < 1) setShowOpis(true);
    }, [showResults, osvojenoBodova]);

    return (
        <div className="flex flex-col  pb-3 border-b border-b-blueHoverLight">
            <div className="flex flex-row gap-5 justify-between ">
                <div className="flex-1">
                    <div className="flex flex-col justify-between gap-2 ">
                        <div className="flex flex-row gap-2">
                            <p className="text-[16px] leading-5 text-blueDark font-medium"> {pitanjeIndex + 1}.</p>
                            <MarkDownView source={item.naziv} />
                        </div>
                        {item.oblastImages && item.oblastImages?.length !== 0 && (
                            <div className="block xl:hidden">
                                <Slideshow images={item.oblastImages} width={300} height={200} />
                            </div>
                        )}
                    </div>
                    <div className="flex flex-col gap-2 mt-4">
                        {item.odgovori?.map((odgovor: any, index: number) => {
                            return (
                                <Odgovor
                                    odgovor={odgovor}
                                    key={odgovor?.id}
                                    pitanjeIndex={pitanjeIndex}
                                    surveyOdgovori={surveyOdgovori}
                                    setSurveyOdgovori={setSurveyOdgovori}
                                    showResults={showResults}
                                />
                            );
                        })}
                    </div>
                </div>
                {item.oblastImages && item.oblastImages?.length !== 0 && (
                    <div className="hidden xl:block">
                        <Slideshow images={item.oblastImages} width={300} height={250} />
                    </div>
                )}
            </div>
            {showResults && (
                <div className="flex flex-col gap-2 mt-3">
                    <MarkDownView source={'Tačan odgovor je: ' + tacanOdgovor?.text} style={{ color: '#00c853' }} />

                    <p className="text-[16px] leading-5 text-blueDark font-bold">
                        Osvojeno bodova: {(surveyOdgovori[pitanjeIndex] && surveyOdgovori[pitanjeIndex].brojBodova) ?? 0}
                    </p>
                    {hasOpis && (
                        <div className="mt-4">
                            <button
                                onClick={() => setShowOpis((prev: boolean) => !prev)}
                                className="text-[16px] leading-5 text-white bg-blueMedium font-medium px-4 py-2 mb-2 text-left rounded-[10px] transition"
                            >
                                {showOpis ? 'Zatvori opis odgovora' : 'Prikaži opis odgovora'}
                            </button>

                            <div
                                className={`bg-orange-50 rounded-lg p-2 ${showOpis ? 'max-h-[1000px] h-auto' : 'max-h-0'} ${showOpis ? 'opacity-100 p-1' : 'opacity-0'} overflow-hidden transition-all`}
                            >
                                <MarkDownView source={item?.opis} />
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default KvizPitanjeSingle;

const Odgovor = ({
    odgovor,
    surveyOdgovori,
    setSurveyOdgovori,
    pitanjeIndex,
    showResults = false,
}: {
    odgovor: any;
    surveyOdgovori: any;
    setSurveyOdgovori: any;
    pitanjeIndex: any;
    showResults?: boolean;
}) => {
    const handleSelectOdgovor = (odgovor: any) => {
        setSurveyOdgovori((prethodnaLista: any[]) => {
            const novaLista = [...prethodnaLista]; // Kopiramo listu
            novaLista[pitanjeIndex] =
                novaLista[pitanjeIndex] === null
                    ? { odgovor, brojBodova: calculateSingleOdgovor(odgovor) } // Ako je null, kreiramo novi objekat
                    : { ...novaLista[pitanjeIndex], odgovor, brojBodova: calculateSingleOdgovor(odgovor) }; // Inače, ažuriramo postojeći objekat
            return novaLista;
        });
    };

    const calculateSingleOdgovor = (odgovor: any) => {
        if (odgovor?.tacan) {
            return 1;
        } else {
            return 0;
        }
    };

    return (
        <button
            className={`w-full max-w-[450px]  ${
                showResults && surveyOdgovori[pitanjeIndex] && surveyOdgovori[pitanjeIndex].odgovor?.id == odgovor?.id && odgovor?.tacan
                    ? 'bg-greenA200'
                    : showResults && surveyOdgovori[pitanjeIndex] && surveyOdgovori[pitanjeIndex].odgovor?.id == odgovor?.id && !odgovor?.tacan
                      ? 'bg-redA200'
                      : surveyOdgovori[pitanjeIndex] && surveyOdgovori[pitanjeIndex].odgovor?.id == odgovor?.id
                        ? 'bg-grey-300'
                        : 'bg-grey-100'
            } flex flex-row gap-4 px-2 md:px-4 py-2 rounded-[10px] transition`}
            onClick={() => handleSelectOdgovor(odgovor)}
            disabled={showResults}
        >
            <div className="border-[1.5px] border-blueDark rounded-full h-[18px] min-w-[18px] flex items-center justify-center mt-[2px]">
                <div
                    className={`rounded-full h-[10px] w-[10px] ${surveyOdgovori[pitanjeIndex] && surveyOdgovori[pitanjeIndex].odgovor?.id == odgovor?.id ? 'bg-blueDark' : ''} transition`}
                ></div>
            </div>
            <MarkDownView source={odgovor.text} />
        </button>
    );
};
